import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import UserService from './user/user.service';
import ArtistService from './artist/artist.service';
import CooperationService from './cooperation/cooperation.service';
import NoteService from './note/note.service';
import TaskService from './task/task.service';
import EventService from './event/event.service';
import ActivityService from './activity/activity.service';
import CooperationInsightService from './cooperation-insight/cooperation-insight.service';
import CustomerService from './customer/customer.service';
import ContactService from './contact/contact.service';
import InsightService from './insight/insight.service';
import DoingService from './doing/doing.service';
import RevenueService from './revenue/revenue.service';
import CooperationContactService from './cooperation-contact/cooperation-contact.service';
import UpdateService from './update.service';
import ReminderService from './reminder.service';
import InvoiceService from './invoice/invoice.service';
import ActionService from './action.service';
import EmailAccountService from './email-account/emailAccount.service';
import CurrencyService from "./currency/currency.service";
import ProfileInsightService from "./profile-insight/profileInsight.service";
import DunService from "./dun/dun.service";
import MediumService from "./insight/medium.service";
import MediaInsightService from "./insight/mediaInsight.service";
import BillingCycleService from "./billing-cycle/billing-cycle.service";
import CompanyService from "./company/company.service";
import GoalService from "./goal/goal.service";
import BrandService from "./brand/brand.service";
import MessagingAccountService from "./messaging/messagingAccount.service";
import MessagingMessageService from "./messaging/messagingMessage.service";
import MessagingThreadService from "./messaging/messagingThread.service";
import MessagingAttachmentService from "./messaging/messagingAttachment.service";
import MessagingFolderService from "./messaging/messagingFolder.service";
import CorrectionService from "./correction/correction.service";
import TeamService from "./team/team.service";
import MessagingThreadEntryService from "./messaging/messagingThreadEntry.service";
import CalendarService from "./calendar/calendar.service";



@NgModule({
  declarations: [],
  imports: [
  ],
  providers: [
    UserService,
    ArtistService,
    CooperationService,
    NoteService,
    TaskService,
    EventService,
    ActivityService,
    CooperationInsightService,
    CooperationContactService,
    CustomerService,
    ContactService,
    InsightService,
    DoingService,
    RevenueService,
    BrandService,
    UpdateService,
    ReminderService,
    InvoiceService,
    ActionService,
    EmailAccountService,
    CurrencyService,
      ProfileInsightService,
      DunService,
      MediumService,
      MediaInsightService,
      BillingCycleService,
      CompanyService,
      GoalService,
      MessagingAccountService,
      MessagingMessageService,
      MessagingThreadService,
      MessagingThreadEntryService,
      MessagingAttachmentService,
      MessagingFolderService,
      CorrectionService,
      TeamService,
      CalendarService,
  ]
})
export class ApiModule { }
